import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4602Model } from '../kymw4602.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type SetTagPCodeResponse = {
  RegistPCodes: string[];
};

/**
 * タグ集約サービス
 *
 * @export SetTagPCodeService
 * @class SetTagPCodeService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class SetTagPCodeService extends PlessJsonResponderSub<SetTagPCodeResponse> {
  private model: KYMW4602Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof AggregateTagService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        TagId: this.model.tagId,
        PCodes: this.model.validLines.join(','),
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof AggregateTagService
   */
  execute(model: KYMW4602Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('setTagPCode', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {SetTagPCodeResponse} data レスポンスデータ
   * @memberof AggregateTagService
   */
  success(data: SetTagPCodeResponse) {
    this.model.registedPCodes = data.RegistPCodes;
    if (this.calbak) this.calbak();
  }
}
